module.exports = __webpack_public_path__ + "public/images/slider/speaker-1.b8ec21998aa67b0e262a9f15c9c5153b.png";